module.exports = __webpack_public_path__ + "img/glogo243.8d825bb8.png";